/*************************************************************************
 * @license
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2026 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

const IMS_AUTH_SCOPE = 'AdobeID,openid,additional_info.ownerOrg,additional_info.roles, '
    + 'read_organizations,account_cluster.read,pps.read';

export const IMS_REAUTHENTICATE_AFTER_SIGNOUT = 'ims.reauthenticateAfterSignOut';
export const SESSION_EXPIRED_PATH = '/session-expired';
export const SESSION_EXPIRED_REASON = 'session_expired';

export default IMS_AUTH_SCOPE;
